import { render, staticRenderFns } from "./Anagrafica5.vue?vue&type=template&id=d604c312&"
import script from "./Anagrafica5.vue?vue&type=script&lang=js&"
export * from "./Anagrafica5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports